import { ENV } from "../utils";

export class WorkPermit {
  baseApi = ENV.BASE_API;

  async getWorkPermits(accessToken, params = {}) {
    const qs = new URLSearchParams();
    if (params.active  !== undefined) qs.set("active",  params.active);
    if (params.site    !== undefined) qs.set("site",    params.site);
    if (params.status  !== undefined) qs.set("status",  params.status);
    if (params.company) qs.set("company", params.company);
    const url = `${this.baseApi}/work-permits?${qs}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getWorkPermit(accessToken, id) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createWorkPermit(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-work-permit`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateWorkPermit(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-work-permit/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteWorkPermit(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-work-permit/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadFile(accessToken, id, formData) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/upload-file`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/work-permit-file/${fileName}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    return URL.createObjectURL(await response.blob());
  }

  async deleteFile(accessToken, id, fileName) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/delete-file`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async duplicateWorkPermit(accessToken, id) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/duplicate`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadCierrePhoto(accessToken, id, formData) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/upload-cierre-photo`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteCierrePhoto(accessToken, id, fileName) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/delete-cierre-photo`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async approveLevel(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/approve-level`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async changeStatus(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/work-permit/${id}/change-status`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
